import React, { useState } from 'react'
import mixpanel from 'mixpanel-browser';

import { Game, gameToTrackData, Participant, Tournament } from '../types'
import { Grid, Button, Divider, Icon, Dropdown, Image, Transition } from 'semantic-ui-react'

import GameModal from './GameModal'
import { useMeleeContext } from '../../draft/context/MeleeContextProvider'

import { ApplyVictory, Revertgame, UpdateGameDraft } from '../utils/TournametActions'
import { GetTeamHash } from '../utils/Evaluator'

import ConfirmModal from '../utils/ConfirmModal'

import { getHeroImage } from 'draft/heroes/useHeroes'

import ManualDraftModal from './ManualDraftModal';

const GameUnit = (props: {
    game: Game,
    tournamnet: Tournament
    showGameModal: boolean
}) => {
    const [gameResultModalOpen, setGameResultModalOpen] = useState(props.showGameModal);
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);

    const [manualDraftModalOpen, setManualDraftModalOpen] = useState(false);

    const [winningAnimation, setWinningAnimation] = useState<'blue' | 'red' | 'none'>('none');



    const meleeContext = useMeleeContext();
    if (!meleeContext) return <></>;

    const teamBlueHash = GetTeamHash(props.game.TeamBlue);
    const winnerHash = GetTeamHash(props.game.Winners);

    const winnerColor = teamBlueHash === winnerHash ? 'blue' : 'red';
    const gameIsFinished = props.game.Winners.length > 0;

    const triggerModal = (isOpen: boolean): void => {
        setGameResultModalOpen(isOpen);
        
    }

    let searchWords = meleeContext!.searchText.split(' ');
    searchWords = searchWords.filter((w) => (w !== ''));
    const TeamColumn = (players: Participant[], teamColor: string) => {
        const RenderPlayers = () => {
            return (
                players.map((p) => {
                    let isHighlighted = searchWords && searchWords[0] !== '' && searchWords.some((w) => p.Name.toLowerCase().includes(w.toLowerCase()));
                    return (
                        <Grid.Column key={'name-colum-' + p.Number}>
                            <Grid.Row>
                                <h3 className={isHighlighted ? 'highlighted' : ''}>{p.Name}</h3>
                            </Grid.Row>
                            {p.Hero &&
                                <Grid.Row style={{ marginTop: 8 }}>
                                    {props.tournamnet.DraftOptions.gameType &&
                                        <Image style={{
                                            margin: 'auto',
                                            width: 32,
                                            height: 32
                                        }} src={getHeroImage(props.tournamnet.DraftOptions.gameType, p.Hero)} />
                                    }
                                </Grid.Row>
                            }
                        </Grid.Column>

                    )
                })
            )
        }

        const isLoser = teamColor !== winnerColor && gameIsFinished ? 'losers' : '';

        return (
            <Transition
                animation='tada'
                duration={2000}
                visible={winningAnimation === 'none' || winningAnimation !== teamColor}
            >
                <Grid.Column style={{ margin: 'auto' }}>
                    <Grid className={'melee-draft-card ' + teamColor + ' ' + isLoser} columns='equal' stackable>
                        {RenderPlayers()}
                    </Grid>
                </Grid.Column>
            </Transition>
        )
    }

    const applyManualDraft = (stage : string, updatedParticipants : Participant[]) => {
        if (meleeContext!.tournament) {
            const updatedTour = UpdateGameDraft(
                meleeContext!.tournament, 
                props.game, 
                stage, 
                updatedParticipants)

            meleeContext!.setTournament(updatedTour)

            setManualDraftModalOpen(false);
            setGameResultModalOpen(true);
        }
    }

    const DeclareWinner = (winner: ('blue' | 'red'), stockDifference: number) => {
        triggerModal(false);

        setWinningAnimation(winner);

        if (meleeContext!.tournament) {
            const updatedTour = ApplyVictory(meleeContext!.tournament, props.game.Id, winner, stockDifference)
            meleeContext!.setTournament(updatedTour)
        }


        mixpanel.track("Game Played", gameToTrackData(props.game,props.tournamnet))

        var tourIsCompleted = true;
        // Check if all games are completed for stats
        props.tournamnet.GroupStageGames.forEach(game => {
            if(game.Winners.length === 0) 
                tourIsCompleted = false;
                return;
        })
        if(tourIsCompleted){
            mixpanel.track("Tournament Completed",
        {
            "name" : props.tournamnet.Name,
            "localID" : props.tournamnet.Id
        })
        }
    }

    const revertGame = () => {
        if (meleeContext!.tournament) {
            const updatedTour = Revertgame(meleeContext!.tournament, props.game.Id)
            meleeContext!.setTournament(updatedTour)
        }
    }

    const PostGameDropdown = (stockDifference: number) => (
        <Dropdown floating inline text={'Score ' + stockDifference} style={{ marginLeft: '12px' }}>
            <Dropdown.Menu>
                <Dropdown.Item style={{ color: 'black!important' }} icon='erase' text='Revert Game' onClick={() => setConfirmModalOpen(true)} />
            </Dropdown.Menu>
        </Dropdown>
    )

    const GameInfoCell = (winnerColor: string) => {
        if (!gameIsFinished) {
            return (
                <>
                    <p>{props.game.Name}</p>
                    {props.game.Heat && <span className='game-name'>Heat {props.game.Heat}</span>}
                    <h3>VS</h3>
                    <Button className='button melee basic' onClick={() => triggerModal(true)}>Play</Button>
                </>
            )
        }

        return (
            <>
                <span className='game-name'>{props.game.Name}</span>
                <h3 className={winnerColor + '-text'}><Icon name='winner' />VICTORY</h3>
                {PostGameDropdown(props.game.StockDifference as number)}
            </>
        )
    }


    return (
        <>
            <Grid columns={3} style={{ margin: '1em 0em' }}>
                {TeamColumn(props.game.TeamBlue, 'blue')}

                <Grid.Column className='game-unit'>
                    {GameInfoCell(winnerColor)}
                </Grid.Column>

                {TeamColumn(props.game.TeamRed, 'red')}
            </Grid>

            <Divider />

            <GameModal
                open={gameResultModalOpen}
                triggerModal={triggerModal}
                game={props.game}
                Tornament={props.tournamnet}
                declareWinner={DeclareWinner}
                openManualDraft={() => {setManualDraftModalOpen(true)}}
            />

            <ManualDraftModal
                isOpen={manualDraftModalOpen}
                close={() => setManualDraftModalOpen(false)}
                applyManualDraft={applyManualDraft}
                players={[...props.game.TeamBlue, ...props.game.TeamRed]}
                gameType={props.tournamnet.DraftOptions.gameType}
                stagePack={props.tournamnet.DraftOptions.stagePack}
            />

            <ConfirmModal
                isOpen={confirmModalOpen}
                onAccept={() => revertGame()}
                textContent={`Are you sure you want to revert ${props.game.Name}?`}
                toggleOpen={setConfirmModalOpen}
            />
        </>
    )

}

export default GameUnit;

